import { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as CustomerIconSvg } from '../../assets/customer-icon.svg';
import Icon from '@ant-design/icons';

export const CustomerIcon = (props: Partial<CustomIconComponentProps>): JSX.Element => {
  return <Icon component={CustomerIconSvg} {...props} />;
};
